import { ModelPsAgreementRequests } from '../../models/fireModels/types'

const defineArea = args => {
  const kickEmailSend = async (record, afterStatus: string = '') => {
    if (!record.id) {
      $core.$toast.error('id がありません')
      return
    }
    // メール送信 kick する
    $core.$loading.start('メール送信中...', 'overlay')
    try {
      const updateData: Partial<ModelPsAgreementRequests> = {
        id: record.id,
        lastSentRequestedAt: $core.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
      }
      if (afterStatus) {
        updateData.status = afterStatus
      }
      await $core.$storeMethods.upsert({
        modelName: 'ps_agreement_requests',
        data: updateData,
        disableAfterSaveFunction: false,
        disableBeforeSaveFunction: true,
        quiet: true,
        disableUserLatestStoreMethodActionTime: true,
      })
    } catch (e) {
      // @ts-ignore
      $core.$toast.error(e.message)
    } finally {
      $core.$loading.finish()
    }
  }
  // Vue コンポーネント定義を作成
  const addingVueComponent = {
    // Vue template part
    template: `
<div class="col-12 text-center py-3 model-form-submit-actions d-flex justify-content-center align-items-center gap-2">
  <button
   v-for="action in displayActionButtons" :key="action.label"
  class="btn" :class="action.class" @click="action.onClick">
    <ficon v-if="action.icon" :type="action.icon" />
    {{action.label}}
  </button>
</div>`,
    // data props
    data() {
      return {}
    },
    // computed props
    computed: {
      givenAttrs() {
        // @ts-ignore
        return this.$attrs
      },
      ModelFormComponent() {
        return $core.$utils.findNearestParentVueComponentByName(this, 'ModelForm')
      },
      record(): any {
        // @ts-ignore
        return this.ModelFormComponent?.data
      },
      displayActionButtons() {
        const previewButton = {
          label: '同意画面プレビュー',
          class: 'btn btn-outline-secondary',
          onClick: () => {
            $core.$ps.openAgreementFlowPreviewModalWithPsAgreementRequest(this.record)
          },
        }
        if (this.record?.status === '下書き') {
          return [
            previewButton,
            {
              label: '下書き状態で保存',
              icon: 'save',
              class: 'btn btn-outline-secondary',
              onClick: () => {
                return this.ModelFormComponent.save()
              },
            },
            {
              label: '送信する',
              icon: 'send',
              class: 'btn btn-success',
              onClick: async () => {
                const savedRecord = await this.ModelFormComponent.save()
                console.log(`savedRecord:`, savedRecord)
                // メール送信 kick する
                await kickEmailSend(savedRecord, '送信済み')
              },
            },
            {
              label: '削除',
              icon: 'trash',
              class: 'btn btn-outline-danger _ml-auto',
              onClick: () => {
                return this.ModelFormComponent.remove()
              },
            },
          ]
        }
        if (this.record?.status === '送信済み') {
          if (this.record?.send_method !== 'URL発行') {
            return [
              previewButton,
              {
                label: '再送信する',
                class: 'btn btn-success',
                onClick: async () => {
                  const savedRecord = await this.ModelFormComponent.save()
                  // メール送信 kick する
                  await kickEmailSend(savedRecord)
                },
              },
            ]
          }
          return [
            previewButton,
          ]
        }
        if (this.record?.status === '同意済み') {
          return [previewButton]
        }
        return []
      },
    },
    // methods
    methods: {
      openAttrsDisplayModal() {
        this.$refs.attrsDisplayModal.show()
      },
    },
  }
  /**
   * パターン1: コンポーネントを "追加する" 場合
   * - $appHook.on の引数 args は 他に 同じHook名で登録された コンポーネントが入る可能性があるため、配列にして返す
   */
  if (!args) {
    args = []
  }
  if (!Array.isArray(args)) {
    args = [args]
  }
  return args.concat(addingVueComponent)

  /**
   * パターン2: コンポーネントを "置き換える" 場合
   * - 作成したVueコンポーネント定義のみを配列として返却することで、他のコンポーネントを排除して置き換えることが可能です。
   */
  // return [addingVueComponent]
}

$core.$appHook.on(
  '$CORE.admin.resolveComponent.model.ps_agreement_requests.edit.modelForm.submitPart',
  args => defineArea(args),
)
